<template>
	<b-modal
		id="govtjobs"
		size="lg"
		centered
		hide-footer
		hide-header
		v-model="showmodal"
		@hidden="$emit('close-modal')"
	>
		<div
			class="d-flex align-items-center p-3 border-bottom-line"
			:class="isLaptop ? ' justify-content-between' : ' justify-content-center'"
			style=""
		>
			<div class="govtjobs-modal-head">
				{{
					selectedJob?.isCurated
						? "Redirect to External Website"
						: "Redirect to " +
						  (selectedJob?.customFields?.gov_job ? "Government" : "External") +
						  " Website"
				}}
			</div>
			<img
				@click="$emit('close-modal')"
				class="rotate-on-hover pointer hideinmob"
				src="../../assets/newdesign/dashboard/blueCross.svg"
				alt=""
			/>
		</div>
		<div
			class="p-3 d-flex flex-column align-items-center justify-content-center"
		>
			<img src="@/assets/job-search-icons/govtjobs.svg" alt="" />
			<div class="mt-3 w-100 text-center">
				<div class="govtjobs-head">
					You will be redirected to external website
				</div>
				<div
					v-if="selectedJob?.customFields"
					class="govtjobs-blueitalic govtjobs-head my-3 text-break url-container"
					v-b-tooltip.hover
					:title="showFullURL ? selectedJob.customFields.redirectURL_ : ''"
				>
					{{ truncatedURL }}
				</div>
				<div class="govtjobs-head mb-2">Click on "Continue" to proceed</div>
			</div>
		</div>
		<div
			:class="
				isLaptop
					? 'justify-content-end p-3'
					: ' justify-content-center pt-0 pb-3 px-3'
			"
			class="candash-modal-footer d-flex align-items-center"
		>
			<b-button
				class="w-120px candash-cancelBtn mr-3"
				@click="$emit('close-modal')"
				>Cancel</b-button
			>
			<b-button
				class="w-120px candash-addBtn"
				@click="openURL(selectedJob.jobID)"
				>Continue</b-button
			>
		</div>
	</b-modal>
</template>

<script>
import commonFunc from "@/components/mixin/commonFunction.js";
export default {
	name: "Govtjobs",
	props: {
		showmodal: Boolean,
		selectedJob: Object,
	},
	mixins: [commonFunc],
	data() {
		return {
			govtjobs: false,
			lineClamp: 2,
		};
	},
	computed: {
		truncatedURL() {
			return this.selectedJob.customFields.redirectURL_;
		},
		showFullURL() {
			const tempDiv = document.createElement("div");
			tempDiv.style.width = "100%";
			tempDiv.style.display = "-webkit-box";
			tempDiv.style.webkitBoxOrient = "vertical";
			tempDiv.style.webkitLineClamp = this.lineClamp;
			tempDiv.style.overflow = "hidden";
			tempDiv.textContent = this.selectedJob.customFields.redirectURL_;

			document.body.appendChild(tempDiv);
			const isOverflowing = tempDiv.scrollHeight > tempDiv.clientHeight;
			document.body.removeChild(tempDiv);

			return isOverflowing;
		},
	},
	methods: {
		openURL(id) {
			window.open(this.selectedJob.customFields.redirectURL_, "_blank");
			this.$emit("storeid", id);
		},
	},
};
</script>

<style scoped>
.border-bottom-line {
	border-bottom: 1px solid #d7d7d7;
}
.govtjobs-modal-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
#govtjobs .modal-body {
	padding: 0;
}
.govtjobs-head {
	font-family: "Lato", sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #000000;
}
.govtjobs-blueitalic {
	font-style: italic;
	color: #20639b;
}

.url-container {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	word-break: break-all;
}

@media (max-width: 1028px) {
	.border-bottom-line {
		border-bottom: unset;
	}
	.hideinmob {
		display: none;
	}
	.govtjobs-modal-head {
		font-family: "Montserrat", sans-serif;
		font-weight: 600;
		font-size: 15px;
		color: #333333;
	}
	.govtjobs-head {
		font-family: "Lato", sans-serif;
		font-size: 14px;
		font-weight: 500;
		color: #000000;
	}
	.w-120px {
		width: 120px !important;
	}
	.candash-modal-footer {
		border-top: unset;
		padding: 0;
	}
}
</style>
